class ServiceWorkerService {
    app;
    constructor(app) {
        this.app = app;
        window.addEventListener('load', this.register.bind(this));
    }

    register() {
        // navigator.serviceWorker.register('/sw.js', {
        //     scope: '/'
        // }).then(this.onSuccess.bind(this)).catch(this.onFail.bind(this));

        navigator.serviceWorker.getRegistrations().then(regs => {
            regs.forEach(reg => {
                reg.unregister().then((registration) => {
                    console.log('✅ Service worker unregistered:', registration);
                })
            });
        });
        // if (caches && caches.keys) {
        //     caches.keys().then(keys => keys.forEach(k => caches.delete(k)));
        // }

        const store = this.app.config.globalProperties.$store;
        const emitter = this.app.config.globalProperties.$emitter;
        window.addEventListener('online', () => {
            store.commit('app/online', true);
            emitter.emit('online');
        });

        window.addEventListener('offline', () => {
            store.commit('app/online', false);
            emitter.emit('offline');
        });
    }

    onSuccess(registration) {
        console.log('✅ Service worker registered:', registration);

        registration.onupdatefound = () => {
            const newWorker = registration.installing;
            newWorker.onstatechange = () => {
                if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                    console.log('✅ New version of service worker is installed!');
                }
            };
        };
    }

    onFail(error) {
        console.error('❌ SW registration failed:', error);
    }
}
export default {
    install(app) {
        if ('serviceWorker' in navigator) {
            new ServiceWorkerService(app);
        }
    }
}